"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _ActionButtonListStyled = require("./ActionButtonList-styled");
var _helper = require("./helper");
var _ActionsModal = _interopRequireDefault(require("../ActionsModal"));
var _calciteComponentsReact = require("@esri/calcite-components-react");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; } // Third-party components (buttons, icons, etc.)
var ActionButtonList = function ActionButtonList(_ref) {
  var actions = _ref.actions,
    showLabel = _ref.showLabel,
    items = _ref.items,
    userSession = _ref.userSession,
    handleQueryChange = _ref.handleQueryChange,
    clearSelectedItems = _ref.clearSelectedItems,
    itemBrowserState = _ref.itemBrowserState,
    getUserFolders = _ref.getUserFolders,
    collapsed = _ref.collapsed,
    itemId = _ref.itemId,
    itemGroups = _ref.itemGroups,
    _ref$visibleActionsCo = _ref.visibleActionsCount,
    visibleActionsCount = _ref$visibleActionsCo === void 0 ? 1 : _ref$visibleActionsCo,
    queryResults = _ref.queryResults;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    modalOpen = _useState2[0],
    setModalOpen = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    activeAction = _useState4[0],
    setActiveAction = _useState4[1];
  var matchingItemGroups = itemGroups ? itemGroups[itemId] : [];
  var toggleModalOpen = function toggleModalOpen(action) {
    if (action) {
      setModalOpen(!modalOpen);
      setActiveAction(action);
    }
  };
  var closeModal = function closeModal() {
    setModalOpen(false);
  };
  var handleActionClick = function handleActionClick(_ref2) {
    var selectedFolderId = _ref2.selectedFolderId;
    if (activeAction) {
      activeAction.onClick({
        items: items,
        queryResults: queryResults,
        userSession: userSession,
        handleQueryChange: handleQueryChange,
        clearSelectedItems: clearSelectedItems,
        selectedFolderId: selectedFolderId ? selectedFolderId : null
      });
    }
  };
  var visibleActions = visibleActionsCount && actions.slice(0, visibleActionsCount);
  var collapsedActions = actions.slice(visibleActionsCount, actions.length);
  var handleActionSelect = function handleActionSelect(e) {
    var onclick = e.target.selectedItems[0].onclick;
    if (itemId) {
      onclick(itemId, e);
    } else if (items) {
      onclick(items, e);
    }
  };
  return /*#__PURE__*/_react.default.createElement(_ActionButtonListStyled.StyledActionButtonList, {
    showLabel: showLabel
  }, /*#__PURE__*/_react.default.createElement(_ActionsModal.default, {
    activeActionId: activeAction === null || activeAction === void 0 ? void 0 : activeAction.id,
    closeModal: closeModal,
    userSession: userSession,
    onActionClick: handleActionClick,
    itemBrowserState: itemBrowserState,
    getUserFolders: getUserFolders,
    items: items,
    queryResults: queryResults,
    modalOpen: modalOpen
  }), showLabel ? actions.map(function (action) {
    return /*#__PURE__*/_react.default.createElement(_calciteComponentsReact.CalciteButton, {
      key: action.id,
      iconStart: action.icon.props.icon,
      appearance: "transparent",
      color: "neutral",
      onClick: function onClick() {
        action.enabledItemBrowserModal ? toggleModalOpen(action) : action.onClick({
          items: items,
          queryResults: queryResults
        });
      }
    }, showLabel && action.label);
  }) : collapsed ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, visibleActions.length && visibleActions.map(function (action) {
    return /*#__PURE__*/_react.default.createElement(_calciteComponentsReact.CalciteTooltipManager, {
      key: action.id
    }, /*#__PURE__*/_react.default.createElement(_calciteComponentsReact.CalciteButton, {
      id: "".concat(action.id, "-tooltip-btn"),
      iconStart: action.icon.props.icon,
      appearance: "transparent",
      color: "neutral",
      onClick: function onClick(event) {
        itemId && action.onClick(itemId, event);
      }
    }), /*#__PURE__*/_react.default.createElement(_calciteComponentsReact.CalciteTooltip, {
      referenceElement: "".concat(action.id, "-tooltip-btn")
    }, action.label));
  }), collapsedActions.length ? /*#__PURE__*/_react.default.createElement(_calciteComponentsReact.CalciteDropdown, {
    placement: "bottom-end",
    onCalciteDropdownSelect: function onCalciteDropdownSelect(event) {
      return handleActionSelect(event);
    }
  }, /*#__PURE__*/_react.default.createElement(_calciteComponentsReact.CalciteButton, {
    slot: "dropdown-trigger",
    iconStart: "ellipsis",
    appearance: "transparent",
    color: "neutral",
    scale: "s"
  }), /*#__PURE__*/_react.default.createElement(_calciteComponentsReact.CalciteDropdownGroup, {
    selectionMode: "single"
  }, actions.slice(visibleActionsCount, actions.length).map(function (action) {
    return /*#__PURE__*/_react.default.createElement(_calciteComponentsReact.CalciteDropdownItem, {
      key: action.id,
      "data-value": action.id,
      onclick: action.onClick
    }, action.label);
  }))) : null) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _helper.getUserIcons)({
    actions: actions,
    itemGroups: matchingItemGroups
  })));
};
var _default = ActionButtonList;
exports.default = _default;